import React, { useState } from 'react'
import useTitle from '@/hooks/useTitle'
import { addIcon,userProfileIcon2  } from '@/assets/img/imgAssets'
import { PlusIcon, MinusIcon, TrashIcon, PencilSquareIcon,  } from '@heroicons/react/24/outline'
import { Square3Stack3DIcon ,CalendarDaysIcon, UserGroupIcon, ListBulletIcon, SwatchIcon, ClockIcon } from '@heroicons/react/24/solid'
import PulseLoader from "react-spinners/PulseLoader"
import { useGetUserImprintEtsQuery } from './userImprintEtsApiSlice'
import { useGetUsersQuery, useGetUserPicQuery } from "@/features/users/usersApiSlice" // 12 May 2025


import EtInspirationBeaconIcon2SVGComp from '@/assets/img/icons/svgComp/EtInspirationBeaconIcon2SVGComp'
import EtGratitudeTypeIcon1SVGComp from '@/assets/img/icons/svgComp/EtGratitudeTypeIcon1SVGComp'

// 12 May 2025
import { formatDateToMonthYear, formatDateToYear, formatDateTime, formatShortDate } from '@/utils/formatDate'
import { getTimeSince } from "@/utils/EtGetTimeSince"
import moment from "moment";

const EtUserImprintEtList = ({setActiveAdminView, onAdd, onUpdate, onDelete, setSelectedEntityId }) => {

    // First Created - 11 May 2025
    // Author - Atul Pandey
    // Updated - 12 May 2025 - Gratitudes
    // Updated - 12 May 2025 - Grouped guests by Org
    // Updated - 12 May 2025 - Added counts - all guests, guests with and without Et Imprint

    // 1 - Set Page Title
    useTitle('User Et Imprints List')

    // 2 - Initialize showDetails state as an object where key is the session index
    
    // const [showImprintDetails, setShowImprintDetails] = useState(null)
    const [showImprintDetails, setShowImprintDetails] = useState({})
    const [showUserImprintEts, setShowUserImprintEts] = useState({})
    const [showGratitudes, setShowGratitudes] = useState(false)
    const [showGratitudeDetails, setShowGratitudeDetails] = useState({})
    const [showOrg, setShowOrg] = useState({})

    // 3 - Extract the User Imprint Ets data
    const { data: userImprintEtsData, isError, error, isLoading } = useGetUserImprintEtsQuery()
    const { data: allUsersData } = useGetUsersQuery()

    // console.log('userImprintEtsData', userImprintEtsData)

    const extractEntitiesFromAdapter = (dataAdapter) => {
        if (!dataAdapter || !dataAdapter.ids || !dataAdapter.entities) return [];
        return dataAdapter.ids.map((id) => dataAdapter.entities[id]);
      };
    
    //   const userImprintEts = extractEntitiesFromAdapter(userImprintEtsData);
    //   console.log('userImprintEts', userImprintEts)
      const userImprintEtsRaw = extractEntitiesFromAdapter(userImprintEtsData)?.filter(item => !item.guestUserOrgId?.organizationName.toLowerCase().includes("eternity")); // 12 May 2025 - Do not include anyone from Eternity
    //   console.log('userImprintEtsRaw', userImprintEtsRaw)

    const allUsers = extractEntitiesFromAdapter(allUsersData)
    // console.log('allUsers', allUsers)

    // Get all non-Eternity guest users (exclude self-org users and org name contains 'eternity')
    const nonEternityGuests = allUsers?.filter(
    user =>
        !user.userOrgId?.organizationName?.toLowerCase().includes("eternity")
    ) || []

    // console.log('nonEternityGuests', nonEternityGuests)


    // 3b - Group by guest org name -- 12 May 2025
    const groupedImprintsByOrg = userImprintEtsRaw.reduce((acc, imprint) => {
        const orgName = imprint?.guestUserOrgId?.organizationName || "Unknown Organization";
        if (!acc[orgName]) acc[orgName] = [];
        acc[orgName].push(imprint);
        return acc;
    }, {});

    // console.log('groupedImprintsByOrg', groupedImprintsByOrg)

    
    // 3c - Build a map of total non-Eternity guests per org
    const orgGuestTotals = nonEternityGuests.reduce((acc, user) => {
        const orgName = user.userOrgId?.organizationName || "Unknown Organization";
        if (!acc[orgName]) acc[orgName] = 0;
        acc[orgName]++;
        return acc;
    }, {});

    // console.log('orgGuestTotals', orgGuestTotals)

    // 3d - Compute pending guest imprints per org
    const orgGuestPendings = Object.entries(orgGuestTotals).reduce((acc, [orgName, totalCount]) => {
        const completedCount = groupedImprintsByOrg[orgName]?.length || 0;
        acc[orgName] = totalCount - completedCount;
        return acc;
    }, {});

    // console.log('orgGuestPendings', orgGuestPendings)

    // 3e - After orgGuestTotals and groupedImprintsByOrg are computed
    const orgStats = Object.keys(orgGuestTotals).reduce((acc, orgName) => {
        const total = orgGuestTotals[orgName] || 0;
        const completed = groupedImprintsByOrg[orgName]?.length || 0;
        const pending = total - completed;
        acc[orgName] = { total, completed, pending };
        return acc;
    }, {});

    // console.log('orgStats', orgStats)

    // 3f - 👇 Merge all org names for full display (with or without imprints)
    const allOrgNames = Array.from(
        new Set([...Object.keys(orgStats), ...Object.keys(groupedImprintsByOrg)])
    );



    // 4a - Toggle Show function for userImprintEt details
    const handleToggleGratitudeDetails = (userImprintEtId) => {
        setShowGratitudeDetails(prev => ({ ...prev, [userImprintEtId]: !prev[userImprintEtId] }));
    }

    // 4b - Toggle Show function for userImprintEts
    const handleToggleUserImprintEts = (userImprintEtId) => {
        setShowUserImprintEts(prev => ({ ...prev, [userImprintEtId]: !prev[userImprintEtId] }));
    }

    // 4c - Toggle the show/hide state for the specific inspirationBeacon index
    // const handleToggle = (index) => {
    //     setShowImprintDetails(prev => prev === index ? null : index);
    // }
    const handleToggle = (key) => {
        setShowImprintDetails(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    }
     // 4d - Toggle Show function for showOrg
     const handleToggleOrg = (orgId) => {
        setShowOrg(prev => ({ ...prev, [orgId]: !prev[orgId] }));
    }

    // 5 - Create an object for setting inner HTML
    const createMarkup = (htmlContent) => {
        return { __html: htmlContent }
    }

    // 6 - Optional: handle loading and error states
    if (isLoading) return <PulseLoader color={"#ea580c"} />
    if (isError) return <div>Error occurred: {error?.data?.message}</div>


    return (
        <div className='bg-gray-200 m-1 p-1 rounded font-poppins mx-auto'>
            {/* Header */}
            <div className='flex justify-between items-center m-1 p-1 border-b pb-2 mb-2 border-white'>
                <div>
                    <p className='text-2xl m-1 p-1 font-bold'>User 360 Imprint - Eternity</p>
                    <p className='text-xs text-gray-600 mx-1 px-1'>
                        Total Guests: <span className='font-bold text-gray-800'>{nonEternityGuests?.length}</span> &nbsp; | &nbsp;
                        Imprints Done: <span className='font-bold text-lime-700'>{userImprintEtsRaw?.length}</span> &nbsp; | &nbsp;
                        Pending: <span className='font-bold text-red-600'>{nonEternityGuests?.length - userImprintEtsRaw?.length}</span>
                    </p>
                </div>
                <div>
                    <img
                        src={addIcon}
                        alt=""
                        className="h-10 w-10 cursor-pointer"
                        onClick={onAdd} 
                    />
                </div>
            </div>

            {userImprintEtsRaw?.length === 0 && (
                    <div><p>No Et guest user imprint data exists. Click above to create one</p></div>
            )}
            
            {/* {Object.entries(groupedImprintsByOrg).map(([orgName, imprints]) => ( */}
            {allOrgNames.map((orgName) => {
                const imprints = groupedImprintsByOrg[orgName] || [];
                return(
                    <div key={orgName} className="">
                        {/* Org Header */}
                        <div className="bg-gray-100 text-gray-700 m-1 p-1 rounded shadow-lg">

                            <div className='m-1 p-1 flex justify-between items-center'>
                                <div className='m-1 p-1 flex justify-start items-center'>                    
                                    <div
                                        onClick={() => handleToggleOrg(orgName)}
                                        className="mx-2 cursor-pointer flex justify-center items-center rounded-full h-5 w-5 hover:shadow-md hover:z-30  hover:bg-white"
                                    >
                                        {showOrg[orgName] ? (
                                        <MinusIcon className="h-4 w-4 text-orange-600 " />
                                        ) : (
                                        <PlusIcon className="h-4 w-4 text-orange-600 " />
                                        )}
                                    </div> 
                                
                                    <p className="text-sm font-bold uppercase tracking-wide">
                                        {orgName}</p>

                                </div>
                                <div>
                                    <p>
                                        <span className="ml-2 text-[11px] text-gray-600 font-normal">
                                            Total: <span className="text-gray-800 font-bold mx-1 px-1">{orgStats[orgName]?.total}</span> | 
                                            Done: <span className="text-lime-700 font-bold mx-1 px-1">{orgStats[orgName]?.completed}</span> | 
                                            Pending: <span className="text-red-600 font-bold mx-1 px-1">{orgStats[orgName]?.pending}</span>
                                        </span>
                                    </p>
                                </div>
                            </div> 

                            {showOrg[orgName] && imprints.length === 0 && (
                            <div className="m-2 p-2 text-xs text-orange-600 bg-white rounded">
                                No guest imprints have been added yet for this organization.
                            </div>
                            )}              

                            {showOrg[orgName] && imprints.length > 0 && imprints?.map((imprint, imprintIndex) => {
                                const guestName = imprint?.guestUserId?.name || ''
                                const guestFirstName = guestName ? guestName.split(' ')[0] : '';
                                const imprintHeadline = imprint?.userImprintEtName || ''
                                const imprintDesc = imprint?.userImprintEtDesc || ''
                                const userId = imprint?.userId?._id || null
                                const userOrgId = imprint?.userOrgId?._id || null
                                const guestUserId = imprint?.guestUserId?._id || null
                                const guestUserOrgId = imprint?.guestUserOrgId?._id || null
                                const guestUserOrgName = imprint?.guestUserOrgId?.organizationName || ""
                                const beacons = imprint?.userInspirationBeacons || [] // 11 May 2025
                                const gratitudes = imprint?.userImprintEtGratitudeNotes || [] // 11 May 2025
                                const commenterName = imprint?.userId?.name || ''
                                const commenter = imprint?.userId?.username || ''
                                const commenterFirstName = commenterName ? commenterName.split(' ')[0] : '';

                                const imprintKey = `${orgName}-${imprintIndex}`;

                            // console.log('beacons', beacons)
                    
                            return(
                                <div key={imprint?._id + imprintIndex} className='m-1 p-1 bg-gray-200 rounded font-poppins'>
                    
                                <div className='grid grid-cols-7 justify-start items-center m-1 p-1'>
                                    <div className='col-span-2 flex justify-start items-center'>
                                        <div
                                            // onClick={() => handleToggle(imprintIndex)}
                                            onClick={() => handleToggle(imprintKey)}
                                            className="mx-2 cursor-pointer flex justify-center items-center rounded-full h-5 w-5 hover:shadow-md hover:z-30  hover:bg-white"
                                        >
                                            {/* {showImprintDetails === imprintIndex ? ( */}
                                            {showImprintDetails[imprintKey] ? (
                                            <MinusIcon className="h-3 w-3 text-orange-600 " />
                                            ) : (
                                            <PlusIcon className="h-3 w-3 text-orange-600 " />
                                            )}
                                        </div> 
                                        <p className='mx-1 px-1 text-xl text-gray-600 font-bold'>{imprintIndex+1}.</p>
                                        <p className='mx-1 px-1 text-sm font-bold'>{guestName}</p>
                                    </div>
                                    <div className='col-span-4'>
                                    <p className='mx-1 px-1 text-gray-800 text-xs'>{imprintHeadline}</p>
                                    </div>
                                    <div className='col-span-1 flex justify-end items-center m-1 p-1 cursor-pointer'
                                    onClick={() => onUpdate(imprint?.id)}
                                    >
                                    <PencilSquareIcon className='h-4 w-4 text-orange-600'/>
                                    </div>
                                </div>
                    
                                {/* {showImprintDetails === imprintIndex && ( */}
                                {showImprintDetails[imprintKey] && (
                                    <div className='bg-white m-1 p-1 rounded fix-nested-lists'>
                                    <p dangerouslySetInnerHTML={createMarkup(imprintDesc)} className='text-xs leading-5 text-gray-700 fix-nested-lists'></p>

                                    {/* Beacons Section */}
                                        <div className='m-1 p-1 border-t'>
                                            <div className='flex justify-start items-center m-1 p-1 w-full rounded'>
                                                <div className=''>
                                                    <EtInspirationBeaconIcon2SVGComp className='h-8 w-8 text-orange-600'/>
                                                </div>
                                                <div>
                                                    <p className='font-bold mx-1 px-1'>Inspiration Beacons</p>
                                                    <p className='text-[10px] mx-1 px-1 italic text-gray-400'>How <span className='text-orange-600'>{guestFirstName}</span> lights up the world?</p>
                                                    <div className='mx-2 px-1 h-[2px] w-3 bg-orange-600 rounded'/>
                                                </div>
                                            </div>  
                                        </div>
                                        <div className='grid grid-cols-3 justify-start items-start m-1 p-1 gap-2'>
                                            {beacons?.length>0 && beacons?.map((beacon,beaconIndex) => {
                                                const beaconName = beacon?.userInspirationBeaconId?.inspirationBeaconName || ""
                                                const beaconPic = beacon?.userInspirationBeaconId?.pic || ""
                                                return (
                                                    <div key={beacon?._id+beaconIndex} className='col-span-1 flex justify-start items-center m-1 p-1'>
                                
                                                        <div className='rounded border border-orange-600 h-9 w-9 flex justify-center items-center bg-white'><img src={beaconPic} className='h-7 w-7' /></div>
                                                
                                                        <div><p className='text-[10px] mx-1 px-1 text-gray-600'>{beaconName}</p></div>
                                                    </div>
                                                )
                                            })}
                                                    
                                        </div>
                                        {beacons.length === 0 && (
                                            <div className='w-full m-1 p-1'>
                                                <p className='text-orange-600 mx-1 px-1 text-xs'>No beacons have been added yet!</p>
                                            </div>
                                        )}
                                    {/* Et Gratitude Notes Section - 12 May 2025 */}
                                        <div className='m-1 p-1 border rounded'>
                                    
                                            <div className='flex justify-start items-center m-1 p-1 w-full rounded'>
                                                <div
                                                    onClick={() => setShowGratitudes(prev => !prev)}
                                                    className="mx-2 cursor-pointer rounded-full h-5 w-5 flex justify-center items-center hover:bg-white"
                                                    >
                                                    {showGratitudes ? (
                                                        <MinusIcon className="h-4 w-4 text-orange-600" />
                                                    ) : (
                                                        <PlusIcon className="h-4 w-4 text-orange-600" />
                                                    )}
                                                </div>
                                    
                                                <div className=''>
                                                    <EtGratitudeTypeIcon1SVGComp className='h-8 w-8 text-orange-600'/>
                                                </div>
                                                <div>
                                                    <p className='font-bold mx-1 px-1'>Gratitude Notes</p>
                                                    <p className='text-[10px] mx-1 px-1 italic text-gray-400'>how is Et grateful to <span className='text-orange-600'>{guestFirstName}</span>?</p>
                                                    
                                                </div>
                                            </div>  
                                    
                                            {showGratitudes && gratitudes.length >0 && gratitudes?.map((gratitude, gratitudeIndex) => {

                                                return(
                                                    <div key={gratitude._id+gratitudeIndex} className='bg-gray-100 rounded m-1 p-1'>
                                    
                                                        <div className='grid grid-cols-7 justify-start items-center'>
                                                            <div className='col-span-2 flex justify-start items-center m-1 p-1'>
                                                                <div>
                                                                    <p className="text-2xl font-bold mx-1 px-1 text-gray-600">{ gratitudeIndex +1}.</p>
                                                                </div>
                                                                <div
                                                                    onClick={() => handleToggleGratitudeDetails(gratitude._id)}
                                                                    className="mx-2 cursor-pointer rounded-full h-5 w-5 flex justify-center items-center hover:bg-white"
                                                                    >
                                                                    {showGratitudeDetails[gratitude._id] ? (
                                                                        <MinusIcon className="h-4 w-4 text-orange-600" />
                                                                    ) : (
                                                                        <PlusIcon className="h-4 w-4 text-orange-600" />
                                                                    )}
                                                                </div>
                                                                
                                                                <div className='flex flex-col justify-center items-center'>
                                                                    <User username={commenter} defaultUserPic={userProfileIcon2} />
                                                                </div>
                                                                <div className='flex flex-col justify-center items-center mx-1 px-1'>
                                                                    <p className='text-[10px] my-1 text-gray-600'>{commenterFirstName}</p>
                                                                    <p className="text-[9px] mx-1 rounded-full px-2 py-[1px] bg-lime-200 w-full">{getTimeSince(gratitude?.userImprintEtGratitudeNoteUpdateDate)}</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-span-3'>
                                                                <p dangerouslySetInnerHTML={createMarkup(gratitude?.userImprintEtGratitudeNoteText)} className="text-[11px] text-gray-700 m-1 p-1 truncate max-w-full line-clamp-1"></p>
                                                            </div>
                                                            <div className="col-span-2 flex justify-center items-center mx-2">
                                                                <ClockIcon className="h-5 w-5 text-lime-600" />
                                                                <p className="text-[9px] mx-1">Created:</p>
                                                                <p className="text-gray-500 text-[10px] ml-1">{moment(gratitude?.userImprintEtGratitudeNoteDate).format('DD MMM YYYY, hh:mm A')}</p>
                                                            </div>
                                                        </div>
                                                        {showGratitudeDetails[gratitude._id] && (
                                                            <div className="m-1 p-1 rounded bg-white">
                                                            <div
                                                                dangerouslySetInnerHTML={createMarkup(gratitude?.userImprintEtGratitudeNoteText)}
                                                                className="text-[11px] text-gray-700 m-1 p-1"
                                                            ></div>
                                                            </div>
                                                        )}     
                                                    </div>
                                                )
                                            })}
                                        </div>



                                    </div>
                                )}

                                




                                </div>
                            )
                            })}
                        </div>
                    </div>
                )
            // ))}
            })}
        </div>
    )
}

const User = ({ username, defaultUserPic }) => {
  const { data: userPic, isFetching: isFetchingUserPic } =
    useGetUserPicQuery(username)

  return (
    <div className="flex justify-center items-center h-12 w-12 rounded-full border border-white bg-gradient-to-r from-orange-600 to-orange-400 shadow-lg shadow-black cursor-pointer">
      {/* Display user picture or loading indicator*/}
      {isFetchingUserPic ? (
        <div>Loading...</div>
      ) : userPic ? (
        <img src={userPic} alt="User" className="h-11 w-11  rounded-full" />
      ) : (
        <img src={defaultUserPic} alt="User" className="h-10 w-10 p-1" />
      )}
    </div>
  )
}

export default EtUserImprintEtList